import React from "react";
import { GatewaySelectContainer } from "./style.js";
import { gatewaysData } from "constants/gatewaysData";
const GetwaySelect = ({ gateways, selected, setGateway }) => {
  if (gateways.length <= 1) return null;
  return (
    <GatewaySelectContainer>
      <h5>پرداخت انلاین از درگاه:</h5>
      <div className="notice">
        قابل پرداخت از طریق کلیه کارت های بانکی عضو شبکه شتاب
      </div>
      {gateways.map((gateway) => (
        <div
          className={`item ${selected === gateway ? "selected" : ""}`}
          key={gateway}
          onClick={() => setGateway(gateway)}
        >
          <img
            src={`/gateways/${gatewaysData[gateway].logo}`}
            alt={gatewaysData[gateway].title}
          />
        </div>
      ))}
    </GatewaySelectContainer>
  );
};
export default GetwaySelect;
